import { Alert, Snackbar } from "@mui/material";
import React from "react";


function NoWordsSnackbar({noWordAlert, handleCloseNoWordAlert,theWord}) {
    return (<Snackbar anchorOrigin={{
  vertical: 'top',
  horizontal: 'center'
  }} open={noWordAlert} autoHideDuration={3000} onClose={handleCloseNoWordAlert}>
    <Alert variant="outlined" onClose={handleCloseNoWordAlert} severity="info" sx={{
  width: '100%'
  }}>
      Oops! No such word as <i><b>{theWord}</b></i>, please try again 🙊
    </Alert>
  </Snackbar>);
  }

  export default NoWordsSnackbar;